<template>
  <div ref="element" class="head-toolbar">
    <span
      class="head-toolbar-button expand-button glyphicon glyphicon-fullscreen"
      v-if="!props.expanded"
      @click="expand"
    ></span>
    <span
      class="head-toolbar-button collapse-button glyphicon glyphicon-resize-small"
      v-if="props.expanded"
      @click="collapse"
    ></span>
  </div>
</template>

<script setup lang="ts">
import { CompositeHeadApiModel } from "../../../api-models";

const props = defineProps<{
  expanded: boolean;
  model: CompositeHeadApiModel | undefined;
}>();

const emit = defineEmits(["expand", "collapse"]);

function expand() {
  emit("expand");
}

function collapse() {
  emit("collapse");
}
</script>

<style lang="less" scoped>
.head-toolbar {
  position: absolute;
  bottom: 10px;
  right: 15px;
}

.head-toolbar-button {
  background-color: unset;
  color: #808080;
  opacity: 0.6;
  user-select: none;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }

  &.expand-button {
    font-size: 28px;
  }

  &.collapse-button {
    font-size: 36px;
  }
}
</style>
